import styled from 'styled-components'
import { Button } from 'components/Button'

export const NoPaddingButton = styled(Button).attrs({
  variant: 'tertiary',
  scale: 'small',
})`
  padding: 0;

  > span {
    margin: 0 !important;
  }
`
